import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useHtmlDocument } from '../../../hooks/html-document';
import { UiBox } from '@open-stack/ui';
import './XDrawerBottom.scss';
import clsx, { ClassValue } from 'clsx';

const elementModalRoot = document.querySelector('#root-modal');

interface Props {
    onClose(): void;
    padding?: number;
    children?: any;
    className?: ClassValue;
}

export function XDrawerBottom({ onClose, padding, children, className }: Props) {
    const [element] = useState(document.createElement('div'));
    useHtmlDocument().useRegisterDialog();

    useEffect(() => {
        if (elementModalRoot) {
            elementModalRoot.appendChild(element);
            return () => {
                elementModalRoot.removeChild(element);
            };
        }
    }, [element]);

    return ReactDOM.createPortal(
        <div className={clsx(className, 'XDrawerBottom')} onClick={onClose}>
            <div className="overlay animate__animated animate__fadeIn" />

            <UiBox className="content" padding={padding}>
                <div
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                    className="content-container">
                    {children}
                </div>
            </UiBox>
        </div>,
        element,
    );
}
